/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ChangeSystemModeRequest {
  /**
   * If serviceName is provided, but serviceInstance is not, then the request will affect all instances of the service. If serviceName is not provided, then all services will be affected.
   */
  serviceName?: string;
  /**
   * If serviceInstance is provided, but serviceName is not, then the error will be returned.
   */
  serviceInstance?: number;
  systemMode: ChangeSystemModeRequest.SystemModeEnum;
}
export namespace ChangeSystemModeRequest {
  export const SystemModeEnum = {
    Active: 'ACTIVE',
    Maintenance: 'MAINTENANCE',
  } as const;
  export type SystemModeEnum = (typeof SystemModeEnum)[keyof typeof SystemModeEnum];
}
